/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交 需求4（任务单 DEV-120352）；
 *          视觉基准 docs/旅游落地页/cj商旅-01.html 第 7490~7882 行（.cjbt-premium-pay）与第 7883~7942 行内联脚本。
 * 注意事项：
 * 1. 左侧支付面板（价格 999 定金 + 四格权益 + 提示 + 双 CTA）/ 右侧套餐详情（CJ Points + Core Values +
 *    Package Includes + Destinations）。
 * 2. 原型脚本仅做一件事：IntersectionObserver(threshold 0.15) 命中加 is-visible 触发进场动画，
 *    reduce-motion 或不支持 IO 时直接置可见 —— 交由 useScrollReveal 复刻。
 * 3. 两处外链（CJEC 票务支付页、WhatsApp、积分商城）在原型中已是真实地址，统一走常量、target=_blank + noopener。
 */
import React from 'react';
import useScrollReveal from './useScrollReveal';
import { ArrowRight } from './Icons';

export default function Payment(props) {
  var PAY = props.data;
  var reveal = useScrollReveal('is-visible', 0.15);

  return (
    <section className="cjbt-premium-pay" id="cjbt-package-payment" ref={reveal}>
      <div className="cjbt-premium-pay__container">
        <article className="cjbt-premium-pay__card">

          {/* LEFT PAYMENT PANEL */}
          <div className="cjbt-premium-pay__payment">

            <span className="cjbt-premium-pay__shine" aria-hidden="true"></span>
            <span className="cjbt-premium-pay__glow" aria-hidden="true"></span>

            <div className="cjbt-premium-pay__payment-content">

              <div className="cjbt-premium-pay__header">
                <div className="cjbt-premium-pay__identity">
                  <div>
                    <h2 className="cjbt-premium-pay__name">{PAY.name}</h2>
                  </div>
                </div>
              </div>

              <div className="cjbt-premium-pay__price-area">
                <span className="cjbt-premium-pay__price-label">{PAY.priceLabel}</span>

                <div className="cjbt-premium-pay__price">
                  <span className="cjbt-premium-pay__currency">{PAY.currency}</span>
                  <span className="cjbt-premium-pay__amount">{PAY.amount}</span>
                </div>

                <strong className="cjbt-premium-pay__deposit">{PAY.deposit}</strong>
                <p className="cjbt-premium-pay__price-description">{PAY.priceDescription}</p>
              </div>

              <div className="cjbt-premium-pay__quick-grid">
                {PAY.quickItems.map(function (item, index) {
                  return (
                    <div className="cjbt-premium-pay__quick-item" key={index}>
                      <strong>{item.title}</strong>
                      <span>{item.text}</span>
                    </div>
                  );
                })}
              </div>

              <div className="cjbt-premium-pay__notice">
                <strong>{PAY.noticeStrong}</strong>{' '}
                {PAY.noticeText}
              </div>

            </div>

            <div className="cjbt-premium-pay__actions">
              <a
                className="cjbt-premium-pay__button cjbt-premium-pay__button--primary"
                href={PAY.primaryCtaHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>{PAY.primaryCta}</span>
                <ArrowRight />
              </a>

              <a
                className="cjbt-premium-pay__button cjbt-premium-pay__button--secondary"
                href={PAY.secondaryCtaHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>{PAY.secondaryCta}</span>
                <ArrowRight />
              </a>
            </div>

          </div>

          {/* RIGHT PACKAGE DETAILS */}
          <div className="cjbt-premium-pay__details">
            <div className="cjbt-premium-pay__details-content">

              <div className="cjbt-premium-pay__details-eyebrow">{PAY.detailsEyebrow}</div>

              <h2 className="cjbt-premium-pay__details-title">
                {PAY.detailsTitleLead} <em>{PAY.detailsTitleEm}</em>
              </h2>

              <p className="cjbt-premium-pay__details-description">{PAY.detailsDescription}</p>

              {/* CJ Points */}
              <div className="cjbt-premium-pay__points">
                <span className="cjbt-premium-pay__points-icon">{PAY.pointsIcon}</span>

                <div className="cjbt-premium-pay__points-content">
                  <span className="cjbt-premium-pay__points-badge">{PAY.pointsBadge}</span>
                  <strong>{PAY.pointsTitle}</strong>
                  <p>{PAY.pointsText}</p>
                </div>

                <a
                  className="cjbt-premium-pay__points-button"
                  href={PAY.pointsCtaHref}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>{PAY.pointsCta}</span>
                  <ArrowRight />
                </a>
              </div>

              {/* Core Values */}
              <div className="cjbt-premium-pay__value-grid">
                {PAY.values.map(function (value, index) {
                  return (
                    <div className="cjbt-premium-pay__value" key={index}>
                      <strong>{value.title}</strong>
                      <span>{value.text}</span>
                    </div>
                  );
                })}
              </div>

              {/* What Your Journey Includes */}
              <div className="cjbt-premium-pay__section-title">{PAY.includesTitle}</div>

              <ul className="cjbt-premium-pay__includes">
                {PAY.includes.map(function (item, index) {
                  return (
                    <li key={index}>
                      <span className="cjbt-premium-pay__check">✓</span>
                      <span>{item}</span>
                    </li>
                  );
                })}
              </ul>

              {/* Destinations */}
              <div className="cjbt-premium-pay__section-title">{PAY.citiesTitle}</div>

              <div className="cjbt-premium-pay__cities">
                {PAY.cities.map(function (city, index) {
                  return <span className="cjbt-premium-pay__city" key={index}>{city}</span>;
                })}
              </div>

            </div>
          </div>

        </article>
      </div>
    </section>
  );
}
